export default __webpack_public_path__ + "static/media/2502112.25df7a44.jpg";